
    import { defineComponent, onMounted, reactive, toRefs, computed } from "vue";
    import ApiLogistics from "@/request/apis/api_logistics";
    import router from "@/router";
    import { message } from "ant-design-vue/es";
    import StorageUtil from "@/utils/storage_util";
    import {
        EditOutlined,
        CheckOutlined,
        CloseOutlined,
    } from "@ant-design/icons-vue";
    import ImageView from "@/components/ImageView.vue";
    import DriverSet from "@/components/DriverSet.vue";
    import PageUtil from "@/utils/page_util";
    import { IDriverItem, IEditDriver } from "@/models/logistics_member";
    import ApiSetting from "@/request/apis/api_setting";
    import apiTalent from "@/request/apis/api_talent";

    interface IState {
        list:any;
        total: number;
        loading: boolean;
        searches: any;
        visible: boolean;
        editItem?: IEditDriver;
        commentDetail:any
    }

    // 表格
    const columns = [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            align:"center"
        },
        {
            title: "公司名称",
            dataIndex: "shop_name",
            key: "shop_name",
            align:"center"
        },
        {
            title: "岗位名称",
            dataIndex: "name",
            key: "name",
            align:"center"
        },
        {
            title: "招聘人数",
            dataIndex: "number",
            key: "number",
            align:"center"
        },
        {
            title: "学历",
            dataIndex: "degree_text",
            key: "degree_text",
            align:"center"
        },
        {
            title: "工作经验",
            dataIndex: "working_year_text",
            key: "working_year_text",
            align:"center"
        },
        {
            title: "岗位职责描述",
            dataIndex: "describe",
            key: "describe",
            align:"center"
        },
        {
            title: "薪资范围",
            dataIndex: "wages",
            key: "wages",
            align:"center"
        },
        {
            title: "岗位地点",
            dataIndex: "province",
            key: "province",
            align:"center"
        },
        {
            title: "地址",
            dataIndex: "address",
            key: "address",
            align:"center"
        },
        {
            title: "状态",
            dataIndex: "del",
            key: "del",
            align:"center"
        },
        {
            title: "发布时间",
            dataIndex: "create_time",
            key: "create_time",
            align:"center"
        },
        {
            title: "操作",
            dataIndex: "action",
            key: "action",
            align:"center"
        },
    ];

    export default defineComponent({
        name: "DriverList",
        components: {
            EditOutlined,
            CheckOutlined,
            CloseOutlined,
            ImageView,
            DriverSet,
        },
        setup() {
            const state: IState = reactive({
                list: [],
                total: 0,
                loading: false,
                commentDetail:'',
                visible:false,
                searches: {
                    page: PageUtil.pageNo,
                    limit: PageUtil.pageSize,
                    name: "",
                    shop_name:"",
                    education:undefined,
                    working_years:undefined,
                    wages_start:"",
                    wages_end:""
                },
            });

            const pagination = computed(() => ({
                total: state.total,
                current: state.searches.page,
                pageSize: state.searches.limit,
                showTotal: (total: any) => `共${total}条数据`,
                defaultPageSize: 10,
                // pageSizeOptions: ['5', '10', '15', '20'], // 可不设置使用默认
                showSizeChanger: true, // 是否显示pageSize选择
                showQuickJumper: true, // 是否显示跳转窗
            }));

            // 列表当前页更改
            const handleTableChange = (pages: any) => {
                state.searches.limit = pages.pageSize;
                state.searches.page = pages.current;
                getList();
            };

            //获取列表
            const getList = async () => {
                let params = { ...state.searches };
                StorageUtil.setParams(params);
                state.loading = true;
                const res = await ApiSetting.postList(params);
                state.loading = false;
                if (res && res.error_code === 0) {
                    state.total = res.data?.total || 0;
                    state.list = res.data?.data || [];
                }
            };

            const onDel = async (val) => {
                const params = {id: val.id}
                const res = await ApiSetting.RecruitPostDel(params)
                if (res) {
                    message.destroy()
                    if (res.error_code === 0) {
                        message.success(res.msg)
                        await getList()
                        return
                    }else{
                        message.error(res.msg)
                    }
                }
            }

            const onSearch = () => {
                getList()
            }

            const onReset = () => {
                state.searches={
                    page: 1,
                    limit: PageUtil.pageSize,
                    name: "",
                    shop_name:"",
                    education:undefined,
                    working_years:undefined,
                    wages_start:"",
                    wages_end:""
                }
                getList()
            }
            onMounted(() => {
                getList();
            });

            return {
                ...toRefs(state),
                columns,
                pagination,
                onSearch,
                onReset,
                onDel,
                handleTableChange
            };
        },
    });
